<pr-modal-confirm
  #invalidIbanModal
  (onConfirm)="onConfirmInvalidIban()"
  (onConfirmOptionnal)="onCancelInvalidIban()"
  [comment]="
    'L\'IBAN que vous avez saisi ne semble pas conforme. Voulez-vous quand même l\'ajouter ?'
  "
  [display]="EaDisplay.warning"
  labelCancel="Corriger"
  labelConfirm="Confirmer"
  title="IBAN non valide"
>
</pr-modal-confirm>
<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="scpis"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (scpi of scpis.controls; track scpi; let i = $index) {
        <mat-step
          [formGroup]="scpi"
          [stepControl]="scpis?.get([i])"
          completed="false"
        >
          <ng-container formGroupName="parameters">
            <ng-template matStepLabel>{{
              scpi?.get('productName')?.value
            }}</ng-template>
            <div class="row row-flex">
              <div class="col col-md-12">
                <pr-input-radio
                  [columns]="3"
                  [derrors]="derrors"
                  [isDefault]="false"
                  [toggle]="true"
                  formControlName="hasDiscount"
                  label="Remise/Parrainage"
                >
                </pr-input-radio>
              </div>
            </div>
            @if (scpi.get('parameters').get('hasDiscount')?.value === true) {
              <div class="row row-flex">
                <div class="col-md-6">
                  <pr-input-radio
                    [columns]="3"
                    [isDefault]="true"
                    [options]="[
                      { value: 'REMISE', label: 'Remise' },
                      { value: 'PARRAINAGE', label: 'Parrainage' },
                      { value: 'APPORTEUR', label: 'Apporteur' },
                    ]"
                    formControlName="discountType"
                    label="Type"
                  >
                  </pr-input-radio>
                </div>
              </div>
              @if (
                scpi.get('parameters').get('discountType')?.value ===
                'PARRAINAGE'
              ) {
                @if (scpi.get('parameters').get('sponsorId')?.value) {
                  <div
                    class="row"
                    style="
                      margin-bottom: 0.5rem;
                      padding: 0.5rem 0.75rem;
                      background-color: #e8f5e9;
                      border-radius: 4px;
                      font-size: 13px;
                      color: #2e7d32;
                      display: flex;
                      align-items: center;
                      gap: 0.5rem;
                    "
                  >
                    <pr-icon name="checkmark"></pr-icon>
                    Parrain sélectionné :
                    {{ scpi.get('parameters').get('discountFirstname')?.value }}
                    {{ scpi.get('parameters').get('discountLastname')?.value }}
                    ({{ scpi.get('parameters').get('discountEmail')?.value }})
                  </div>
                }
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-autosuggest
                      [additionalOptionLabel]="[
                        {
                          name: 'firstName',
                          useParentheses: true,
                          useDash: false,
                        },
                        {
                          name: 'lastName',
                          useParentheses: true,
                          useDash: false,
                        },
                      ]"
                      [derrors]="derrors"
                      [isDefault]="false"
                      [loading]="searchingSponsors"
                      [noCustom]="true"
                      [options]="sponsors"
                      formControlName="sponsorEmail"
                      label="Email du parrain"
                      optionLabel="login"
                      placeholder="Rechercher un parrain par email"
                    >
                    </pr-input-autosuggest>
                    @if (
                      sponsorsSearched &&
                      sponsors.length === 0 &&
                      !searchingSponsors
                    ) {
                      <div
                        style="
                          margin-top: 0.5rem;
                          color: #ff9800;
                          font-size: 14px;
                          display: flex;
                          align-items: center;
                          gap: 0.5rem;
                        "
                      >
                        <pr-icon name="info-circle"></pr-icon>
                        Aucun parrain trouvé avec cet email. Vérifiez
                        l'orthographe ou contactez le support.
                      </div>
                    }
                  </div>
                </div>
              }
              @if (
                scpi.get('parameters').get('discountType')?.value ===
                'APPORTEUR'
              ) {
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column
                      [derrors]="derrors"
                      [isDefault]="false"
                      label="Email de l'apporteur"
                    >
                      <input
                        formControlName="contributorEmail"
                        placeholder="exemple@email.com"
                        type="email"
                      />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column
                      [derrors]="derrors"
                      [isDefault]="false"
                      label="Prénom de l'apporteur"
                    >
                      <input
                        formControlName="contributorFirstName"
                        placeholder="Prénom"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column
                      [derrors]="derrors"
                      [isDefault]="false"
                      label="Nom de l'apporteur"
                    >
                      <input
                        formControlName="contributorLastName"
                        placeholder="Nom"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                </div>
              }
              <div class="row">
                <div class="col-md-12">
                  <pr-input-column
                    [derrors]="derrors"
                    [isDefault]="false"
                    label="Montant de la remise"
                    suffix="€"
                  >
                    <input
                      formControlName="discountAmount"
                      notdot
                      type="number"
                    />
                  </pr-input-column>
                </div>
              </div>
              <!-- IBAN pour REMISE : avec sélection d'IBAN existant -->
              @if (
                scpi.get('parameters').get('discountType')?.value === 'REMISE'
              ) {
                <ng-container formGroupName="discountIban">
                  <title
                    [style]="{
                      'font-size': '16px',
                      color: '#3376F6',
                      'margin-top': '2rem',
                      'margin-bottom': '1rem',
                    }"
                    direction="left"
                  >
                    IBAN sur lequel sera versé la remise :
                  </title>
                  <debit
                    [derrors]="derrors"
                    control="parameters.discountIban"
                  ></debit>
                </ng-container>
              }
              <!-- IBAN pour PARRAINAGE : sélection parmi les IBAN du parrain ou saisie manuelle -->
              @if (
                scpi.get('parameters').get('discountType')?.value ===
                'PARRAINAGE'
              ) {
                <ng-container formGroupName="discountIban">
                  <title
                    [style]="{
                      'font-size': '16px',
                      color: '#3376F6',
                      'margin-top': '2rem',
                      'margin-bottom': '1rem',
                    }"
                    direction="left"
                  >
                    IBAN sur lequel sera versé la remise :
                  </title>
                  <discount-iban
                    [derrors]="derrors"
                    [ibans]="sponsorIbans[i]"
                    control="parameters.discountIban"
                  ></discount-iban>
                </ng-container>
              }
              <!-- IBAN pour APPORTEUR : saisie manuelle uniquement -->
              @if (
                scpi.get('parameters').get('discountType')?.value ===
                'APPORTEUR'
              ) {
                <ng-container formGroupName="discountIban">
                  <title
                    [style]="{
                      'font-size': '16px',
                      color: '#3376F6',
                      'margin-top': '2rem',
                      'margin-bottom': '1rem',
                    }"
                    direction="left"
                  >
                    IBAN sur lequel sera versé la remise :
                  </title>
                  <div class="row">
                    <div class="col col-xs-12 col-sm-12 col-md-12">
                      <pr-input-column [derrors]="derrors" label="Titulaire">
                        <input formControlName="holder" type="text" />
                      </pr-input-column>
                    </div>
                    <div class="col col-xs-12 col-sm-12 col-md-12">
                      <pr-input-column
                        [derrors]="derrors"
                        label="Domiciliation bancaire"
                      >
                        <input formControlName="bankName" type="text" />
                      </pr-input-column>
                    </div>
                    <div class="col col-xs-12 col-sm-12 col-md-12">
                      <pr-input-column [derrors]="derrors" label="BIC">
                        <input formControlName="bic" type="text" />
                      </pr-input-column>
                    </div>
                    <div class="col col-xs-12 col-sm-12 col-md-12">
                      <pr-input-column [derrors]="derrors" label="IBAN">
                        <input
                          [showMaskTyped]="true"
                          formControlName="iban"
                          mask="AA00 AAAA AAAA AAAA AAAA AAAA AAAA AAAA AA"
                          type="text"
                        />
                      </pr-input-column>
                    </div>
                  </div>
                </ng-container>
              }
            }
          </ng-container>
        </mat-step>
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
